<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedItems.length > 0" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold User
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ getSelectedUsers() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")        
        v-progress-circular.mr-1(v-if="isLoadingInit" :width="2" :size="11" indeterminate)
        v-icon.mr-1(v-else size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold User
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} user
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading || isLoadingInit" type="text@3")
      div(v-else)
        template(v-if="users.length > 0")
          div(v-for="user in users" :key="user.value")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(user)")
              yc-checkbox(:input-value="isChecked(user.value)" @change="clickItem(user)")
              .ml-4 {{ user.label }}
            v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No user found
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    isLoading: true,
    isLoadingInit: false,
    searchText: '',
    users: [],
    checkedItems: [],
    selectedItems: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledButton () {
      return this.checkedItems.length === 0
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
    showMenu (value) {
      if (!value) {
        this.checkedItems = [...this.selectedItems]
      }
    }
  },
  mounted () {
    this.fetchUsers()
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    async setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.isLoadingInit = true
          let ids = this.filter.value.split(',')
          try {
            let items = []
            for (let i = 0; i < ids.length; i++) {
              const params = { fields: 'id,name' }
              await this.$axios.get(`/clinics/${this.company.slug}/members/${ids[i]}`, { params })
                .then(resp => {
                  items.push({ label: resp.data.name, value: `${resp.data.id}` })
                })
            }
            this.checkedItems = JSON.parse(JSON.stringify(items))
            this.selectedItems = JSON.parse(JSON.stringify(items))
          } catch {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          } finally {
            this.isLoadingInit = false
          }
        }
      }
    },
    fetchUsers () {
      this.isLoading = true
      const params = {
        fields: 'id,name',
        page_size: -1,
        search: this.searchText || ''
      }
      this.$axios.get(`/clinics/${this.company.slug}/members`, { params })
      .then(resp => {
        if (resp.data?.results) {
          this.users = resp.data.results.map(item => {
            return {
              label: item.name,
              value: `${item.id}`
            }
          })
        } else {
          this.users = []
        }
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.checkedItems = []
      this.selectedItems = []
    },
    apply () {
      this.showMenu = false
      this.selectedItems = this.checkedItems
      this.$emit('update:filter', { key: 'members', value: this.checkedItems.map(i => i.value).join(',')})
    },
    clickItem (item) {
      if (this.checkedItems.map(i => i.value).includes(item.value)) {
        this.checkedItems = this.checkedItems.filter(x => x.value !== item.value)
      } else {
        this.checkedItems.push(item)
      }
    },
    getSelectedUsers () {
      const count = this.selectedItems.length
      if (count <= 2) {
        return this.selectedItems.map(x => x.label).join(', ')
      }
      return `${count} selected`
    },
    queryChanged: debounce(function () {
      this.fetchUsers()
    }, 750),
    isChecked (value) {
      return this.checkedItems.filter(item => item.value === value).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>